import { string } from 'prop-types'
import Conditional from '../Conditional'
import { kuiperClassNames } from '../utils'
import './styles.scss'

const FormHeader = ({ title }) => (
  <Conditional condition={title}>
    <div className={kuiperClassNames('form-header')}>
      <h1 id="form-title">{title}</h1>
    </div>
  </Conditional>
)

FormHeader.propTypes = {
  title: string,
}

export default FormHeader
